
/**
 * GSC SAFE JSON UTILS
 * Robust parsing and stable stringification for cryptographic signatures.
 */

export function safeJsonParse<T>(text: string | undefined | null, fallback?: T): T {
    if (!text) return (fallback || {}) as T;
    try {
        let cleaned = text.trim();
        if (cleaned.startsWith('```json')) {
            cleaned = cleaned.replace(/```json/g, "").replace(/```/g, "");
        } else if (cleaned.startsWith('```')) {
            cleaned = cleaned.replace(/```/g, "");
        }
        const firstBrace = cleaned.indexOf('{');
        const lastBrace = cleaned.lastIndexOf('}');
        if (firstBrace !== -1 && lastBrace !== -1 && lastBrace > firstBrace) {
            cleaned = cleaned.substring(firstBrace, lastBrace + 1);
        }
        return JSON.parse(cleaned) as T;
    } catch (e) {
        console.warn("[JSON] Parse error:", e);
        return (fallback || {}) as T;
    }
}

/**
 * Sérialisation déterministe (Keys sorted alphabetically)
 * Indispensable pour que SHA-256(Object) soit stable.
 * Correction : Ignore les valeurs 'undefined' pour matcher le comportement standard de JSON.stringify.
 */
export function stableStringify(obj: any): string {
    if (obj === undefined) return "null"; // JSON.stringify behavior in arrays
    if (obj === null || typeof obj !== 'object') return JSON.stringify(obj);
    if (Array.isArray(obj)) return `[${obj.map(item => stableStringify(item)).join(',')}]`;
    
    // Pour les objets, on trie les clés et on ignore les valeurs undefined
    const keys = Object.keys(obj)
        .filter(k => obj[k] !== undefined)
        .sort();
        
    return `{${keys.map(k => `${JSON.stringify(k)}:${stableStringify(obj[k])}`).join(',')}}`;
}
